module.exports = __webpack_public_path__ + "img/IC_Baja.50bacccb.svg";